<template>
    <main-layout>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/MainLayout.vue';

export default {
    name: 'Profile',
    components: {
        MainLayout,
    },
}
</script>

<style lang="scss">
</style>